var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
var EmailValidatorDirective = /** @class */ (function () {
    function EmailValidatorDirective() {
        this.validator = this.validatEmailFactory();
    }
    EmailValidatorDirective_1 = EmailValidatorDirective;
    EmailValidatorDirective.prototype.validatEmailFactory = function () {
        return function (c) {
            if (c.value == null) {
                return null;
            }
            var REGEXP = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
            return REGEXP.test(c.value) ? null :
                { 'isWrong': true };
        };
    };
    EmailValidatorDirective.prototype.validate = function (c) {
        return this.validator(c);
    };
    var EmailValidatorDirective_1;
    EmailValidatorDirective = EmailValidatorDirective_1 = __decorate([
        Directive({
            selector: '[validator-email][ngModel]',
            providers: [
                { provide: NG_VALIDATORS, useExisting: forwardRef(function () { return EmailValidatorDirective_1; }), multi: true }
            ]
        })
    ], EmailValidatorDirective);
    return EmailValidatorDirective;
}());
export { EmailValidatorDirective };
